import { useLogtoToken } from '@/hooks/useLogtoToken'
import { isLogtoEnabled } from '@/providers/LogtoProviderWrapper'

/**
 * Token bridge component.
 *
 * Connects Logto authentication to API calls.
 * Does not render anything in development mode (Logto not configured).
 */
export function LogtoTokenSetup() {
  if (!isLogtoEnabled()) {
    return null
  }

  return <LogtoTokenSetupInner />
}

function LogtoTokenSetupInner() {
  useLogtoToken()
  return null
}
